export const APP_BASE_URL = '/app';

export const SQL_DATE_FORMAT = 'YYYY-MM-DD';
export const SQL_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const MOMENT_DATE_FORMAT = 'MMM d, YYYY';
export const MOMENT_DATETIME_FORMAT = 'MMM d, YYYY h:mm a';

export const NG_DATE_FORMAT = 'M/d/yy';
export const NG_DATETIME_FORMAT = 'M/d/yy H:mm a';

export const NG_NO_DATA = '-';

export const SNACK_BAR_MESSAGES = {
  FORM_INVALID: 'Please complete all required fields',
  LOADING: 'One moment...',
};

export const ENUMS = {};

export const LOCAL_STORAGE_KEY = {
  AUTH: {
    AUTH_TOKEN: '__ilwu_ops_auth_authToken',
    REFRESH_TOKEN: '__ilwu_ops_auth_refreshToken',
    EXPIRES_IN: '__ilwu_ops_auth_expiresIn',
    USER: '__ilwu_ops_auth_user',
  },
};
